import { Modal } from "@faire/web--source/slate/deprecated/Modal";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import { AppModalType } from "./AppDownload";
import { TextAppSection } from "./TextAppSection";

interface IProps {
  eventPrefix?: string;
  appModalType?: AppModalType;
  onClose: () => void;
}

export const AppDownloadModal: React.FC<IProps> = ({
  eventPrefix,
  appModalType,
  onClose,
}) => (
  <Modal
    onClose={onClose}
    width="400px"
    height="auto"
    padding={getSpacing("8x", "5x")}
    align="stretch"
  >
    <Typography variant="pageHeaderSerifRegular" align="center">
      <StrictLocalMsg defaultMessage="Download the Faire app" />
    </Typography>
    <Spacer height="1x" />
    <TextAppSection
      eventPrefix={eventPrefix}
      appModalType={appModalType}
      onClose={onClose}
    />
  </Modal>
);
